import React, { useContext, useState } from 'react'
import { SessionContextStore } from '../../context/SessionContext'
import {
  Grid,
  Accordion,
  AccordionDetails,
  IconButton,
  useMediaQuery,
  AccordionSummary,
  Container,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import PilotRank from './Ranks/PilotRank'
import { TextButton } from '../Core/Buttons/TextButton'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { isBrowser } from 'react-device-detect'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useHistory } from 'react-router-dom'
var classNames = require('classnames')

export const SafetyScore = () => {
  const sessionContext = useContext(SessionContextStore)
  const [expanded, setExpanded] = useState(isBrowser)
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))
  const history = useHistory()
  const uploadFlightLogs = () => history.push(`flight-logs`)
  const toggleExpand = () => setExpanded(!expanded)

  return (
    <>
      <div className="margin-top-basic relative">
        <Accordion className="transparent" elevation={0} expanded={expanded}>
          <AccordionSummary className="unset-cursor">
            <Grid container spacing={6}>
              <Grid item xs={10} sm={10} md={6}>
                <div className="text-title blue bold">Average Safety Score</div>
                <div className="text-body black margin-top-basic">
                  Skywatch.AI encourages pilots to fly safe
                </div>
                <div className="text-body black bold margin-top-small">
                  Get up to 30% discounts based on your performance!
                </div>
                <div className="margin-top-basic">
                  <TextButton
                    onClick={uploadFlightLogs}
                    text="Upload your flight logs"
                    withBorder
                    startIcon={<CloudUploadIcon />}
                  />
                </div>
              </Grid>
              {isMobile ? (
                <>
                  <Grid item xs={2}>
                    <FlexView hAlignContent={'right'}>
                      <IconButton onClick={toggleExpand}>
                        <ExpandMoreIcon
                          className={classNames('fa-arrow-down', {
                            open: expanded,
                          })}
                        />
                      </IconButton>
                    </FlexView>
                  </Grid>
                  <Grid item xs>
                    <FlexView hAlignContent={'center'}>
                      <PilotRank userProfile={sessionContext.user} />
                    </FlexView>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs>
                    <FlexView hAlignContent={'center'}>
                      <PilotRank userProfile={sessionContext.user} />
                    </FlexView>
                  </Grid>
                  <Grid item xs>
                    <FlexView hAlignContent={'right'}>
                      <IconButton onClick={toggleExpand}>
                        <ExpandMoreIcon
                          className={classNames('fa-arrow-down', {
                            open: expanded,
                          })}
                        />
                      </IconButton>
                    </FlexView>
                  </Grid>
                </>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <FlexView column>
              <div className="text-body bold blue">How does it work?</div>
              <FlexView column className="text-small black">
                <ul>
                  <li>
                    Every flight gets a score based on telemetry parameters such
                    as altitude, battery level, flight zones, etc
                  </li>
                  <li>
                    Discounts are available based on your average Safety Score
                  </li>
                  <li>
                    The discount is based on previous flights, including those
                    flown in the SkyWatch
                    <br />
                    apps or from flight logs submitted
                  </li>
                  <li>
                    A minimum of 5 flights with 5 minutes airtime per flight is
                    needed to get initial score
                  </li>
                  <li>
                    Your Safety Score can be adjusted over time by uploading
                    more flight logs
                  </li>
                </ul>
                <Container maxWidth={'xs'}>
                  <img
                    className="score-info margin-top-basic"
                    src={process.env.PUBLIC_URL + '/assets/score-info.png'}
                  />
                </Container>
              </FlexView>
            </FlexView>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
